// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input-container {
  width: 100%;
  margin-bottom: 16px;
}

.text-input-label {
  display: block;
  margin-bottom: 8px;
}

.text-input-wrapper {
  position: relative;
  width: 100%;
}

.text-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-sm);
  font-family: 'Urbanist', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  background-color: var(--color-white);
  color: var(--color-black);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.text-input::placeholder {
  color: var(--color-gray);
  font-family: 'Urbanist', sans-serif;
}

.text-input:focus {
  outline: none;
  border-color: var(--color-primary-green);
  box-shadow: 0 0 0 3px var(--accent-softer);
}

.text-input-error {
  border-color: var(--color-warning-red);
}

.text-input-error:focus {
  border-color: var(--color-warning-red);
  box-shadow: 0 0 0 3px rgba(255, 45, 85, 0.1);
}

.text-input-measure {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: transparent;
  pointer-events: none;
  width: calc(100% - 32px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.text-input-error-message {
  margin-top: 8px;
  display: block;
}

/* Responsive design */
@media (max-width: 768px) {
  .text-input {
    padding: 10px 14px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
  
  .text-input-measure {
    left: 14px;
    width: calc(100% - 28px);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Text/TextInput.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;EAC/B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".text-input-container {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.text-input-label {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.text-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.text-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-sm);\n  font-family: 'Urbanist', sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n  background-color: var(--color-white);\n  color: var(--color-black);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n}\n\n.text-input::placeholder {\n  color: var(--color-gray);\n  font-family: 'Urbanist', sans-serif;\n}\n\n.text-input:focus {\n  outline: none;\n  border-color: var(--color-primary-green);\n  box-shadow: 0 0 0 3px var(--accent-softer);\n}\n\n.text-input-error {\n  border-color: var(--color-warning-red);\n}\n\n.text-input-error:focus {\n  border-color: var(--color-warning-red);\n  box-shadow: 0 0 0 3px rgba(255, 45, 85, 0.1);\n}\n\n.text-input-measure {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: transparent;\n  pointer-events: none;\n  width: calc(100% - 32px);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n}\n\n.text-input-error-message {\n  margin-top: 8px;\n  display: block;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .text-input {\n    padding: 10px 14px;\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n  \n  .text-input-measure {\n    left: 14px;\n    width: calc(100% - 28px);\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
